var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgFolder(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 27 28",
    fill: "none",
    stroke: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M1.788 24.69L1 11.23a.961.961 0 01.961-1.077h8.865a.98.98 0 01.942.73L12.537 14h12.499a.963.963 0 01.961 1.038l-.75 9.614a1.923 1.923 0 01-1.923 1.77H3.711a1.923 1.923 0 01-1.923-1.731zM6.768 6.307V2.461A.961.961 0 017.73 1.5h16.344a.962.962 0 01.962.961v7.692M14.46 6.307h5.769",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgFolder;